import {ChangeDetectionStrategy, Component} from '@angular/core';
import {IFilterAngularComp} from 'ag-grid-angular';
import {IDoesFilterPassParams, IFilterParams} from 'ag-grid-community';


@Component({ standalone: false,
    selector: 'irb-irb-ag-single-select-column-filter',
    templateUrl: './irb-ag-single-select-column-filter.component.html',
    styleUrls: ['./irb-ag-single-select-column-filter.component.scss']
})
export class IrbAgSingleSelectColumnFilterComponent implements IFilterAngularComp {
    inputvalues: any = [];
    filterValues: any = [];
    multiple: boolean = true;
    checkbox: boolean = true;
    filter: boolean = true;
    private params: any;
    private model: any;
    filterText: any= null;
    suppressInputSearch: boolean = false;
    isVisible: boolean = false;

    agInit(params: IFilterParams): void {
        this.params = params;
        if (params.column.getColDef().filterParams.values) {
            this.inputvalues = params.column.getColDef().filterParams.values;
            this.filterValues = params.column.getColDef().filterParams.values;
            this.suppressInputSearch = params.column.getColDef().filterParams.suppressInputSearch || false;
        }
    }

    afterGuiAttached() {
        this.isVisible = true;
    }

    afterGuiDetached() {    
        this.isVisible = false;
    }

    isFilterActive(): boolean {
        let isActive = false;
        if(this.model) {
            isActive =(this.model && this.model !== null && this.model.value !== null);
        }
        return isActive;
    }

    doesFilterPass(params: IDoesFilterPassParams): boolean {
        let field = this.params.column.getColDef().field;
        let isPassed = true;
        if (this.isFilterActive()) {
            if (params && params.data) {
                isPassed = params.data[field] === this.model.value;
            }
        }
        return isPassed;
    }

    getModelAsString(): any {
        return this.isFilterActive() ? this.model.label?.toString() : null;
    }

    getModel(): any {
        if (this.isFilterActive()) {
            return {value: this.model.value, filterType:'IrbAgSingleSelectColumnFilterComponent'};
        } else {
            return null;
        }
    }

    setModel(model: any): void {
        this.model = model;
    }

    onClearAction(): void {
        this.clearAllValues();
        this.filterValues = [].concat(this.inputvalues);
        this.params.filterChangedCallback();
        this.isVisible = false;
    }

    clearAllValues(): void {
        this.filterText = null;
        this.setModel(null);
    }

    onSelectItem(item: any) {
        this.filterText = null;
        this.filterValues = [].concat(this.inputvalues);
        this.setModel(item);
        this.params.filterChangedCallback();
        this.isVisible = false;
    }
    onFilterTextChange(){
        let f: Array<any> = [];

        if(this.filterText) {
            const r = new RegExp(this.filterText.toLowerCase(), "gi");

            this.inputvalues.forEach((item: any) => {
                if(item.label.toLowerCase().match(r)) {
                    f.push(item);
                }
            });
        } else {
            f = [].concat(this.inputvalues);
        }
        this.filterValues = f;
    }
}



